"use client"

import { getSiteUrl } from "@repo/shared"
import { useEffect } from "react"

import "./index.css"

//欧洲cookieconsent许可协议 右下角弹窗
const CookieConsentCmp = () => {
  const privacyPolicyUrl = `${getSiteUrl("www")}/compliance-center/privacy-policy`
  const whatupUrl = "https://api.whatsapp.com/send/?phone=8618721310824&text&type=phone_number&app_absent=0"
  useEffect(() => {
    // 动态导入 vanilla-cookieconsent 库和样式
    Promise.all([
      import("vanilla-cookieconsent"),
      // @ts-expect-error - CSS 模块导入在动态导入中不需要类型定义
      import("vanilla-cookieconsent/dist/cookieconsent.css"),
    ])
      .then(([CookieConsentModule]) => {
        const CookieConsentApi = CookieConsentModule.default || CookieConsentModule

        CookieConsentApi.run({
          cookie: {
            name: "SMM_cookie_Consent",
            // 替换为你的根域名，确保 a.xxx.com 和 b.xxx.com 都能读取
            domain: process.env.NODE_ENV === "production" ? ".metal.com" : "testlocal.metal.com",
            path: "/",
            sameSite: "Lax",
            expiresAfterDays: 365,
          },

          guiOptions: {
            consentModal: {
              layout: "box",
              position: "bottom left",
              equalWeightButtons: true,
              flipButtons: false,
            },
          },

          // 这里的配置决定了哪些脚本会被拦截
          categories: {
            necessary: {
              readOnly: true,
            },
            analytics: {
              services: {
                ga: {
                  label: "Google Analytics",
                  onAccept: () => {
                    console.warn("GA enabled")
                    // 这里可以手动触发 GA 加载逻辑
                  },
                  onReject: () => {
                    console.warn("GA disabled")
                  },
                },
              },
            },
          },

          language: {
            default: "en",
            translations: {
              en: {
                consentModal: {
                  title: "We use cookies",
                  description: `Our website uses tracking cookies to understand how you interact with it. The tracking will be enabled only if you accept explicitly. For more details relative to cookies and other sensitive data, please read the full <a href="${privacyPolicyUrl}" class="cc__link">privacy policy</a>.`,
                  acceptAllBtn: "Accept",
                  acceptNecessaryBtn: "Reject",
                  showPreferencesBtn: "Manage preferences",
                  // closeIconLabel: 'Reject all and close modal',
                },
                preferencesModal: {
                  title: "Manage cookie preferences",
                  acceptAllBtn: "Accept all",
                  acceptNecessaryBtn: "Reject all",
                  savePreferencesBtn: "Accept current selection",
                  closeIconLabel: "Close modal",
                  serviceCounterLabel: "Service|Services",
                  sections: [
                    {
                      title: "Cookie Usage",
                      description: `We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="${privacyPolicyUrl}" class="cc__link">privacy policy</a>.`,
                    },
                    {
                      title: "Strictly Necessary",
                      description:
                        "These cookies are essential for the proper functioning of the website and cannot be disabled.",

                      //this field will generate a toggle linked to the 'necessary' category
                      linkedCategory: "necessary",
                    },
                    {
                      title: "Performance and Analytics",
                      description:
                        "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.",
                      linkedCategory: "analytics",
                      cookieTable: {
                        caption: "Cookie table",
                        headers: {
                          name: "Cookie",
                          domain: "Domain",
                          desc: "Description",
                        },
                        body: [
                          {
                            name: "_ga",
                            domain: location.hostname,
                            desc: "Google Analytics",
                          },
                          {
                            name: "_gid",
                            domain: location.hostname,
                            desc: "Google Analytics",
                          },
                        ],
                      },
                    },
                    {
                      title: "Targeting and Advertising",
                      description:
                        "These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.",
                      linkedCategory: "ads",
                    },
                    {
                      title: "More information",
                      description: `For any queries in relation to my policy on cookies and your choices, please <a href="${whatupUrl}">contact us</a>`,
                    },
                  ],
                },
              },
            },
          },
        })
      })
      .catch((error) => {
        console.error("Failed to load Cookie Consent library:", error)
      })
  }, [])

  return null // 该组件只负责逻辑，不直接渲染 UI 元素（由库自动插入 DOM）
}

export default CookieConsentCmp
